module.exports = __webpack_public_path__ + "img/h1.001bdc42.jpg";